export const patientsRoutes = (apiBase) => ({
  buscarPacienteApim: (ident, tipoId) => `${apiBase}/procesar?ident=${ident}&tipo_id=${tipoId}`,
  tiposIdentificacion: `${apiBase}/tipoid`,
  getPacientes: `${apiBase}/patients`,
  getResultCreatinina: (ident, tipoId) => `${apiBase}/patients/creatinine?ident=${ident}&tipoId=${tipoId}`,
  getLatestPatientResult: (ident, tipoId, consecutivo) =>
    `${apiBase}/patients/result-latest?ident=${ident}&tipo_id=${tipoId}&consecutivo=${consecutivo}`,
  savePhone: `${apiBase}/patients/phone`,
  saveMail: `${apiBase}/patients/email`,
  saveAddress: `${apiBase}/patients/address`,
  getGeneralData: (tipo, id) => `${apiBase}/patients/general-data?tipo=${tipo}&id=${id}`,
  updateGeneralData: `${apiBase}/patients/status`,
  getPacienteExt: (identificacion) => `${apiBase}/patients/sync?ident=${identificacion}`,
  exportPacienteExt: `${apiBase}/patients/export`,
  processPatientMassUpload: `${apiBase}/patients/mass-upload`,
  schedulePatientMassUpload: `${apiBase}/patients/mass-upload/schedule`,
  getPendingPatientMassUploads: `${apiBase}/patients/mass-upload/pending`,
  getLastExecutedPatientMassUpload: `${apiBase}/patients/mass-upload/last-executed`,
  getPatientMassUploadHistory: `${apiBase}/patients/mass-upload/history`,
  getPatientMassUploadIssues: (jobId) => `${apiBase}/patients/mass-upload/errors?jobId=${jobId}`,
  getLastPatientMassUpload: `${apiBase}/patients/mass-upload/last`,
  getLastPatientMassUploadErrors: `${apiBase}/patients/mass-upload/last/errors`,
  registrarBusquedaPaciente: `${apiBase}/patients/search-log`,
});
